<div
  class="relative flex cursor-pointer items-center gap-2 overflow-hidden rounded-xl p-2 shadow-md hover:bg-blue-light"
  [ngClass]="selected() ? 'bg-blue-primary text-white hover:text-gray-1' : 'bg-gray-5'"
>
  <div class="absolute right-0 top-0">
    <div
      class="flex w-fit items-center justify-end rounded-bl-xl px-2 py-0.5 text-xs text-white"
      [ngClass]="getThreadTypeLabelColor(thread().threadType, selected())"
    >
      <span>{{ getThreadTypeLabel(thread().threadType) }}</span>
    </div>
  </div>
  <div class="mr-2 flex h-12 w-12 min-w-12 items-center justify-center rounded-full bg-gray-3 text-2xl shadow-md">
    <mat-icon>account_circle</mat-icon>
  </div>
  <main class="flex min-w-0 flex-1 flex-col text-lg">
    <div class="flex gap-4">
      <div class="flex items-center gap-4 text-sm">
        <strong>{{ thread().ownerName }}</strong>
      </div>
    </div>
    <div class="flex flex-col gap-1 text-xs">
      <div class="flex items-center overflow-hidden">
        <span class="truncate">
          {{ thread().latestSentMessage ?? "" }}
        </span>
      </div>
      @if (thread().latestSentMessage) {
        <span>{{ thread().lastSentAt | date: "d MMM HH:mm" }}</span>
      }
    </div>
  </main>
  <div class="relative flex items-center gap-1 self-end">
    @if (hasDraft()) {
      <div class="flex h-5 w-5 items-center justify-center">
        <mat-icon
          class="!text-base"
          [inline]="true"
          [fontIcon]="'edit'"
        ></mat-icon>
      </div>
    }
    @if (unreadCount() > 0) {
      <div class="flex h-5 w-5 items-center justify-center rounded-full bg-red-error text-xs text-white">
        {{ unreadCount() > 9 ? "9+" : unreadCount() }}
      </div>
    }
    <div
      class="relative flex h-5 w-5 items-center justify-center rounded-full text-xs"
      (click)="onTogglePin($event)"
    >
      @if (pinLoading()) {
        <shared-spin-loading [size]="12"></shared-spin-loading>
      } @else {
        <mat-icon
          class="!text-base"
          [inline]="true"
          [ngClass]="{ 'rotate-45 !text-red-error-dark': isThreadPinned() }"
          [fontIcon]="'push_pin'"
        ></mat-icon>
      }
    </div>
  </div>
</div>
